export default "<div class='preorder-type-chip'>\n\t{{ 'preorder_type.' + preorderType | translate }}\n</div>\n";